<div class="audio-container">
  <h2>Audio</h2>
  <h3>Audio Description</h3>
  <p-editor [(ngModel)]="feature.value.description" [style]="{ height: '320px' }" [modules]="quillConfiguration"></p-editor>
  <h3>Audio Attachments</h3>
  <div *ngIf="!feature?.value?.items?.length" class="dropzone" appDnd (fileDropped)="audioDropped($event)">
    <p>Drag and drop one audio file here</p>
    <p>or</p>
    <a class="browse-link" (click)="audioDropRef.click()">Browse by clicking here</a>
    <input type="file" #audioDropRef id="audioDropRef" (change)="audioBrowse($event.target.files)"
           accept=".mp3,.wav,.ogg,.m4a" [attr.maxFileSize]="maxAudioSize" />
    <p class="file-info">Compatible formats : mp3, wav, ogg, m4a. Limit of {{maxAudioSize / 1000000}} mb.</p>
  </div>
  <ng-container *ngIf="feature.value?.items?.length > 0">
    <div class="audio-items">
      <div class="audio-item" *ngFor="let file of feature.value.items; index as i;">
        <img *ngIf="file.type === 'Audio'" src="assets/images/Audio.svg" alt="Audio file" />
        <span class="file-name">{{file.name}}</span>
        <button pButton icon="pi pi-trash" (click)="deleteAudio(i)" 
                pTooltip="Remove" tooltipPosition="bottom"></button>
      </div>
    </div>
  </ng-container>

</div>